import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-722816b1"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "partner"
};
const _hoisted_2 = {
  class: "imgs"
};
const _hoisted_3 = ["src"];
const __default__ = {
  name: "partner-home"
};
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {
    // import { ref } from "vue";
    // function getImgs() {
    //   for(var i=0; i<22; i++){
    //     // imgs.value.push(require("@/assets/banks/bank-" + i + ".png"));
    // }
    // getImgs();
    return (_ctx, _cache) => {
      const _component_ModuleName = _resolveComponent("ModuleName");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_ModuleName, {
        name: "超50家合作机构"
      }), _createElementVNode("div", _hoisted_2, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(18, item => {
        return _createElementVNode("img", {
          src: require('@/assets/banks/bank-' + item + '.png' + ''),
          key: item,
          alt: ""
        }, null, 8, _hoisted_3);
      }), 64))])]);
    };
  }

});